import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "../lib/api";

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-black border-t border-white/10 py-14 sm:py-20">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src="/logo.png"
              alt="Black Yellow Taxi 24H"
              className="h-20 sm:h-24 w-auto"
            />
            <p className="mt-6 text-neutral-400 leading-relaxed max-w-md">
              Premium 24-hour taxi service in Barcelona. Local drivers, modern fleet, and
              transparent pricing.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FFC300] mb-5">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-neutral-300">
                <Phone className="w-4 h-4 mt-0.5 text-[#FFC300] flex-shrink-0" />
                <a href={`tel:${COMPANY.phone}`} data-testid="footer-phone" className="hover:text-[#FFC300] transition-colors">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-neutral-300">
                <Mail className="w-4 h-4 mt-0.5 text-[#FFC300] flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-[#FFC300] transition-colors break-all">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-neutral-300">
                <MapPin className="w-4 h-4 mt-0.5 text-[#FFC300] flex-shrink-0" />
                <span data-testid="footer-address">{COMPANY.address}</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FFC300] mb-5">
              Quick Links
            </h4>
            <ul className="grid grid-cols-2 gap-3">
              {[
                ["Home", "#home"],
                ["Fleet", "#fleet"],
                ["Destinations", "#destinations"],
                ["Book Ride", "#book"],
                ["Reviews", "#reviews"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-sm text-neutral-300 hover:text-[#FFC300] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* About Us — full width */}
        <div className="mt-12 sm:mt-16 p-6 sm:p-8 lg:p-10 border border-white/10 bg-[#0A0A0A]" data-testid="about-us-section">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFC300] font-bold mb-4">
            About Us
          </div>
          <div className="space-y-4 text-sm sm:text-base text-neutral-300 leading-relaxed max-w-5xl">
            <p>
              Welcome to <span className="text-white font-semibold">Black Yellow Taxi 24H</span>,
              your trusted taxi service in the heart of Barcelona.
            </p>
            <p>
              Our story began with a simple idea — to create a taxi company that combines
              reliability, comfort, and personal service for both locals and visitors exploring
              this beautiful city. What started as a small family-run service with just one
              vehicle quickly grew through dedication, professionalism, and the trust of our
              customers.
            </p>
            <p>
              From airport transfers to city tours and daily transportation, our mission has
              always been to make every passenger feel safe, comfortable, and welcomed. Inspired
              by the vibrant streets and iconic landmarks of Barcelona, we built a service that
              reflects the city itself — modern, friendly, and always moving.
            </p>
            <p>
              Whether you are visiting Barcelona for the first time or are a regular customer,
              we are here to make your journey smooth, comfortable, and unforgettable.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Black Yellow Taxi 24H — Barcelona, Spain</div>
        </div>
      </div>
    </footer>
  );
}
